<div class="subscription-error-container">
  <div class="error-card">
    <div class="error-header">
      <h2>Subscription Required</h2>
    </div>
    <div class="error-body">
      <div class="error-icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <p class="error-message">{{ errorMessage }}</p>
      <p class="error-info">
        Your access has been temporarily suspended due to a subscription issue. 
        Please contact support or try logging in again.
      </p>
      <div class="error-actions">
        <button class="btn btn-primary" (click)="renewSubscription()">Renew Subscription</button>
        <button class="btn btn-secondary" (click)="goToLogin()">Return to Login</button>
        <button class="btn btn-outline-secondary" (click)="contactSupport()">Contact Support</button>
      </div>
    </div>
  </div>
</div>
